import script from "./RequestTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestTableItem.vue?vue&type=script&setup=true&lang=js"

import "./RequestTableItem.vue?vue&type=style&index=0&id=3cc37324&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc37324"]])

export default __exports__